export const NET_DIRECTORY_FILE_SLICE = 'NET_DIRECTORY_FILE_SLICE';
export const netDirectoryFileLoadMessage = 'Загрузка начата.'
    + ' Дождитесь завершения загрузки данных перед закрытием модального окна.';

export const NetDirectoryFileErrorMessages = {
    LOAD_FILE_NAME: 'Ошибка при выгрузке файлов из сетевой папки.',
    LOAD_FILE: 'Произошла непредвиденная ошибка при запуске программы. Обратитесь к администратору',
    DATA_LOADING: 'Загрузка данных еще не завершена.',
};
